import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import './common/i18n'
import * as serviceWorker from './serviceWorker'
import LoadingView from './common/LoadingWrapper/LoadingView'
import { buildTargets } from './common/constants/UserRoleConstants'
import './index.css'

function importBuildTarget() {
   if (process.env.REACT_APP_BUILD_TARGET === buildTargets.operator) {
      return import('./operator/routes/App/index')
   }
   return import('./common/routes/App/index')
}
export const SuspenseFallbackCmp = (): JSX.Element => (
   <div className='suspense-loading-view'>
      <LoadingView />
   </div>
)
importBuildTarget().then(({ default: App }) =>
   // eslint-disable-next-line react/no-render-return-value
   ReactDOM.render(
      <Sentry.ErrorBoundary fallback={'An error has occurred'}>
         <Suspense fallback={<SuspenseFallbackCmp />}>
            <App />
         </Suspense>
      </Sentry.ErrorBoundary>,

      document.getElementById('root')
   )
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
